import React from 'react'
import { TextField, Box } from '@mui/material'
import { useField } from 'formik'
import { styled } from '@mui/system'
import CreditCardInput from '../creditCardInput/input'

const StyledLabel = styled('span')(({ theme }) => ({
  color: theme.typography.Label.color,
  fontSize: theme.typography.Label.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  textAlign: 'left',
  fontStyle: 'normal',
  letterSpacing: '-0.1px',
  marginBottom: '4px',
  marginTop: '4px',
}))

const StyledAsterisk = styled('span')({
  color: 'red',
})

const StyledTextField = styled(TextField)(({ error }) => ({
  ...(error && {
    borderColor: '#979797',
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
    },
  }),
}))

const ReusableTextfield = ({ name, disabled = false, ...Properties }) => {
  const [field, meta] = useField(name)
  const configTextfield = {
    ...field,
    ...Properties,
    fullWidth: true,
    variant: 'outlined',
  }

  if (meta.touched && meta.error) {
    configTextfield.error = true
    configTextfield.helperText = meta.error
  } else if (name === 'password') {
    configTextfield.helperText = ''
  }

  if (configTextfield.value === 0) {
    configTextfield.value = ''
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <StyledLabel>
        {Properties.id}
        &nbsp;
        {Properties.required ? <StyledAsterisk>*</StyledAsterisk> : ''}
      </StyledLabel>
      {name === 'cvv' && (
        <StyledTextField
          {...configTextfield}
          type="text"
              value={Properties.formik.values.cvv ?? ""}   // ← OVERRIDE VALUE HERE
          inputProps={{
            pattern: "\\d*",
          }}
          onChange={(e) => {
            const raw = e.target.value.replace(/\D/g, ""); // Remove non-digits
            const limit =
              Properties.formik.values.cardBrand?.cvvLength ?? 3;

            Properties.formik.setFieldValue("cvv", raw.slice(0, limit));
          }}
          disabled={disabled}
        />
      )
      }
      {name === 'cardNumber' && (
        <CreditCardInput
          name={name}
          formik={Properties.formik}
          onBrandChange={(brand) => Properties.formik.setFieldValue("cardBrand", brand)}

        />
      )
      }
      {(name !== 'cardNumber' && name !== 'cvv') && (

        <StyledTextField
          {...configTextfield}
          error={meta.touched && meta.error}
          disabled={disabled}
        />
      )}
    </Box>
  )
}

export default ReusableTextfield
